.features {
  flex: 1;
  gap: var(--mirai-ui-space-S);
}

.features .item {
  align-items: center;
  gap: var(--mirai-ui-space-XXS);
}
